import React, { type FC, useState } from "react";
import classes from "./BottomNavbar.module.css";
import BrowseMenu from "./BrowseMenu";
import { useNavigate } from "react-router-dom";

type BottomNavbarProps = {
  activeLink?: number | null;
};

const BottomNavbar: FC<BottomNavbarProps> = ({ activeLink }) => {
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleNavigate = (path: string) => {
    navigate(path, {
      state: {
        reset: true,
      },
    });
  };
  return (
    <>
      <div className={classes.bottom_navbar}>
        <div className={classes.bottom_navbar_items}>
          <button
            className={`${classes.navbar_item} ${
              activeLink === 1 && classes.active
            }`}
            onClick={() => handleNavigate("/home")}
          >
            <div className={classes.navbar_icon}>
              <img
                src="/assets/navbar-icons/home-active.png"
                alt="home"
                className={classes.icon_img}
              />
            </div>
            <p className={classes.nav_text}>Home</p>
          </button>
          <button
            className={`${classes.navbar_item} ${
              activeLink === 2 && classes.active
            }`}
            onClick={() => handleNavigate("/movies")}
          >
            <div className={classes.navbar_icon}>
              <img
                src="/assets/navbar-icons/popcorn-active.png"
                alt="movies"
                className={classes.icon_img}
              />
            </div>
            <p className={classes.nav_text}>Movies</p>
          </button>

          <button className={classes.menu_item} onClick={() => setOpen(true)}>
            <i className={`pi pi-chevron-up ${classes.menu_icon}`} />
          </button>

          <button
            className={`${classes.navbar_item} ${
              activeLink === 3 && classes.active
            }`}
            onClick={() => handleNavigate("/series")}
          >
            <div className={classes.navbar_icon}>
              <img
                src="/assets/navbar-icons/television-active.png"
                alt="home"
                className={classes.icon_img}
              />
            </div>
            <p className={classes.nav_text}>Series</p>
          </button>
          <button
            className={`${classes.navbar_item} ${
              activeLink === 4 && classes.active
            }`}
            onClick={() => handleNavigate("/shortz")}
          >
            <div className={classes.navbar_icon}>
              <img
                src="/assets/navbar-icons/clapper-active.png"
                alt="home"
                className={classes.icon_img}
              />
            </div>
            <p className={classes.nav_text}>Shortz</p>
          </button>
        </div>
      </div>
      <BrowseMenu open={open} setOpen={setOpen} />
    </>
  );
};

export default BottomNavbar;
